import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../lib/adminApi';

export const useAdminAuth = () => {
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    let active = true;
    adminApi.get('/api/admin/verify')
      .then(() => { if (active) setVerified(true); })
      .catch(() => navigate('/admin-login'));
    return () => { active = false; };
  }, [navigate]);

  const logout = useCallback(async () => {
    try {
      await adminApi.post('/api/admin/logout');
    } catch {
      // session already invalid; proceed to login
    }
    navigate('/admin-login');
  }, [navigate]);

  return { verified, logout };
};
